import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestEventPageApi from '@infrastructure/family-fest-event-page-api';
export const getFamilyFestEventPageContentAsync = createAsyncThunk('familyFestEventPage/getContent', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestEventPageApi.getFamilyFestEventPageContent(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFamilyFestEventPageContentAsync = createAsyncThunk('familyFestEventPage/updateContent', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestEventPageApi.updateFamilyFestEventPageContent(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const uploadFamilyFestEventPageImageAsync = createAsyncThunk('familyFestEventPage/uploadImage', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestEventPageApi.uploadFamilyFestEventPageImage(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const removeFamilyFestEventPageImageAsync = createAsyncThunk('familyFestEventPage/removeImage', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestEventPageApi.removeFamilyFestEventPageImage(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const applyFamilyFestEventPageTranslationAsync = createAsyncThunk('familyFestEventPage/applyTranslation', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestEventPageApi.applyFamilyFestEventPageTranslation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
